export enum AuthGetterEnum {
  IS_ADMIN = 'isAdmin',
  HAS_PRIVILEGE = 'hasPrivilege'
}
